const actionTypes = {
  SET_PRODUCT_LIST_PAGE_DATA: "SET_PRODUCT_LIST_PAGE_DATA",
};
export default actionTypes;
